import React, { useMemo } from 'react';
import { getCSVColumns } from '../../constants/cloudAccountsConstants';
import { getCSVData } from '../../CloudAccountsUtil';
import { useTableHeaderContext } from 'shared/components/tableHeader/TableHeaderContext';
import { CreateCloudAccountTableHeader } from '../CreateCloudAccountTableHeader';
import { CloudAccountsTableHeaderTitle } from './TableHeaderTitle';
import TableHeader from 'shared/components/tableHeader/TableHeader';
import { CloudChip } from '../CloudChip';
import styles from '../../CloudAccounts.module.scss';
import { usePermissions } from '~/app/contexts/PermissionsContext.jsx';
import { CategoryAction, HierarchicalEntityCategory } from '@anodot-cost/rbac-client';

export const CloudAccountsTableHeader = ({
  filteredData,
  accounts,
  chipFilterClicked,
  cloudTypeChips,
  showUncompletedOnboardingAccounts,
  setShowUncompletedOnboardingAccounts,
  usersStore,
  currencyContext,
}) => {
  const { isCreateMode, setIsCreateMode } = useTableHeaderContext();
  const csvData = useMemo(
    () => getCSVData(filteredData, getCSVColumns(currencyContext.active)),
    [filteredData, currencyContext.active],
  );
  const { isHasPermission } = usePermissions();

  if (isCreateMode) {
    return <CreateCloudAccountTableHeader usersStore={usersStore} setIsCreateMode={setIsCreateMode} />;
  }

  return (
    <>
      <TableHeader
        tableName="Cloud Accounts"
        disableCreateOption={!isHasPermission(HierarchicalEntityCategory.Accounts, CategoryAction.Create) || usersStore.isCurrentUserReCustomer}
        titleComponent={
          <CloudAccountsTableHeaderTitle
            filteredData={filteredData}
            accounts={accounts}
            showUncompletedOnboardingAccounts={showUncompletedOnboardingAccounts}
            setShowUncompletedOnboardingAccounts={setShowUncompletedOnboardingAccounts}
          ></CloudAccountsTableHeaderTitle>
        }
        csvData={{ data: csvData, filename: 'accounts.csv' }}
      />
      <div className={styles.counters}>
        {cloudTypeChips.map((chip) => (
          <CloudChip key={`${chip.cloudTypeId}-chip`} onClick={() => chipFilterClicked(chip)} chip={chip} />
        ))}
      </div>
    </>
  );
};

